"use client";

import PageHero from "@/app/components/elements/PageHero";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/app/components/shadcn/accordion";

import { faqs } from "./sorular.data";
import { trackGeneric } from "@/app/lib/tracking/interactions";

export default function SorularContent() {
  return (
    <div className="min-h-screen bg-white">
      <PageHero
        eyebrow="Tozlu.com · Destek"
        title="Sıkça Sorulan Sorular"
        description="Yardım ihtiyacınız hangi konuda? Aşağıdan ilgili konuyu bulabilirsiniz."
        breadcrumbs={[
          { title: "Ana Sayfa", url: "/" },
          { title: "Sıkça Sorulan Sorular" },
        ]}
      />

      <div className="container-minify py-14 max-w-4xl">
        <Accordion
          type="single"
          collapsible
          defaultValue="uyelik"
          onValueChange={(value) => {
            // Yalnızca açılış (kapanışta value boş gelir) track edilir.
            if (value) trackGeneric(`faq_${value}`, "click");
          }}
        >
          {faqs.map((faq) => (
            <AccordionItem key={faq.id} value={faq.id}>
              <AccordionTrigger className="text-base font-semibold text-gray-900 hover:no-underline py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-500 leading-relaxed pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* CTA */}
        <div className="mt-16 bg-gray-50 border border-gray-100 rounded-2xl p-8 text-center">
          <h2 className="text-base font-bold text-gray-900 mb-2">
            Aradığınız cevabı bulamadınız mı?
          </h2>
          <p className="text-sm text-gray-500 mb-5">
            Müşteri hizmetlerimiz 09:00 – 23:59 saatleri arasında 7 gün hizmetinizdedir.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="tel:08504400055"
              onClick={() => trackGeneric("faq_phone_call", "click")}
              className="inline-flex items-center justify-center px-5 py-2.5 bg-gray-900 text-white text-sm font-medium rounded-xl hover:bg-black transition-colors"
            >
              0850 440 0055
            </a>
            <a
              href="https://wa.me/905374475666"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackGeneric("whatsapp", "click")}
              className="inline-flex items-center justify-center px-5 py-2.5 bg-white border border-gray-200 text-gray-700 text-sm font-medium rounded-xl hover:border-gray-400 transition-colors"
            >
              WhatsApp ile Yaz
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
